import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';
import * as crypto from 'crypto-js';
// import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private readonly _loadingCtrl: LoadingController,
    private readonly _translate: TranslateService,
    private _auth: AuthService,
  ) {
  }

  /**
   * App version
   */
  get appVersion() {
    const APP_VERSION = '1.3.50';

    return {
      production: true,
      version: APP_VERSION,
    }
  }

  /**
   * Loading
   */
  private _loader: any = null;
  public async presentLoading(message: string | undefined = undefined) {
    this._loader = await this._loadingCtrl.create({
      message: message ?? this._translate.instant('core.loading'),
      spinner: 'circles' 
    });
    this._loader.present(); 
  }

  public closeLoading() {
    if(this._loader) {
      this._loader.dismiss();
    }
  }

  /**
   * Sentry context disabled due to removal of external DSN (TD-226)
   * Keeping method commented in case future Sentry integration is needed
   */
  // public async setSentryContext() {
  //   const user = await this._auth.getLogin();
  //   if(!user) {
  //     Sentry.setUser(null);

  //     return;
  //   }

  //   Sentry.setUser({
  //     id: user.user.id,
  //     email: user.user.email,
  //   });
  // }

  /**
   * Get QR Type
   */
  public getQrType(qrhash: string) {
    if (qrhash.includes('assistant-profile')) return 'assistant';
    if (qrhash.includes('product-qr')) return 'seller';
    if (qrhash.includes('membership')) return 'membership';
    if (this.isUUid(qrhash)) return 'assistant';

    return '';
  }

  /**
   * Check if a string is a valid UUID.
   */
  public isUUid(uuid: string) {
    const uuidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidPattern.test(uuid);
  }

  /**
   * OTEL TraceId
   */
  private _otelTraceId: string = '';
  public get otelTraceId() {
    if(this._otelTraceId) {
      return this._otelTraceId;
    }

    // Generate a OTEL Trace ID
    const randomBytes = crypto.lib.WordArray.random(16);
    const traceId = randomBytes.toString(crypto.enc.Hex);

    this._otelTraceId = traceId;

    return this._otelTraceId;
  }
    
}